module.exports = __webpack_public_path__ + "img/Path 844-1.03665c7d.svg";